import { Loader, ModalParts } from 'BreetComponents';
import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import { useFormStage } from 'BreetHooks';
import { useGetSavedWalletAddressesQuery } from 'BreetRedux';
import type { FC } from 'react';

import { Form } from './components/form/Form';
import { WithdrawUsdRequestProvider } from './components/FormProvider';
import { WithdrawRequestUsdFormStageContext } from './components/FormStageContext';
import SendCryptoTransactionDetails from './components/SendCryptoTransactionDetails';
import {
	DialogWithdrawUsdAddWalletAddress,
	DialogWithdrawUsdScanWalletAddress,
	DialogWithdrawUsdWalletAddressesManage,
	DialogWithdrawUsdWalletAddressesSaved,
} from './components/walletAddresses';
import { requestPaymentUsdStageTitle, type WITHDRAWREQUESTUSDSTAGETYPE } from './DialogWithdrawUsdRequest.helpers';

const DialogWithdrawUsdRequest = () => {
	const { isFetching: isFetchingSavedWalletAddress } = useGetSavedWalletAddressesQuery(undefined, alwaysRefetchApiQueryOptions);

	const formStage = useFormStage<WITHDRAWREQUESTUSDSTAGETYPE>(
		'withdraw-funds',
		[
			'withdraw-funds',
			'add-wallet-address',
			'saved-wallet-address',
			'manage-wallet-address',
			'scan-wallet-address',
			'crypto-transaction-details',
		],
		requestPaymentUsdStageTitle
	);

	const { isStageActive, stageTitle, navigator } = formStage;

	const stageComponents: Record<WITHDRAWREQUESTUSDSTAGETYPE, FC> = {
		'withdraw-funds': Form,
		'add-wallet-address': DialogWithdrawUsdAddWalletAddress,
		'saved-wallet-address': DialogWithdrawUsdWalletAddressesSaved,
		'manage-wallet-address': DialogWithdrawUsdWalletAddressesManage,
		'scan-wallet-address': DialogWithdrawUsdScanWalletAddress,
		'crypto-transaction-details': SendCryptoTransactionDetails,
	};

	return (
		<WithdrawRequestUsdFormStageContext.Provider value={formStage}>
			<WithdrawUsdRequestProvider>
				{isFetchingSavedWalletAddress ? (
					<Loader />
				) : (
					<ModalParts.Wrapper
						title={stageTitle}
						rightSheet
						root={requestPaymentUsdStageTitle['withdraw-funds']}
						handleBackLink={navigator.historyBack}
					>
						{Object.entries(stageComponents).map(([stage, Component]) => (
							<ModalParts.Stage
								hide={!isStageActive(stage as WITHDRAWREQUESTUSDSTAGETYPE)}
								key={stage}
							>
								<Component />
							</ModalParts.Stage>
						))}
					</ModalParts.Wrapper>
				)}
			</WithdrawUsdRequestProvider>
		</WithdrawRequestUsdFormStageContext.Provider>
	);
};

export default DialogWithdrawUsdRequest;
